import {Component, HostBinding, HostListener, Input, OnInit} from '@angular/core';

@Component({
  selector: 'dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  @HostBinding('style.position') position = 'absolute';
  @HostBinding('style.top') y = '0px';
  @HostBinding('style.left') x = '0px';
  @HostBinding('style.visibility') visibility = 'hidden';
  @Input() @HostBinding("style.width") width = "200px";

  inherited;

  constructor() {
  }

  ngOnInit() {
  }

  get() {
    return this.inherited;
  }

  open(e: MouseEvent, inherited = undefined) {
    this.inherited = inherited;
    this.x = `${e.pageX - 100}px`;
    this.y = `${e.pageY}px`;
    this.visibility = 'visible';
    e.stopPropagation();
  }

  close() {
    this.visibility = 'hidden';
  }

  @HostListener('document:click')
  onDocumentClick() {
    if (this.visibility === 'visible') {
      this.close();
    }
  }
}
